/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Group_PlanningInputs */

const en_settings_group_planning = /** @type {(inputs: Settings_Group_PlanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planning`)
};

const de_settings_group_planning = /** @type {(inputs: Settings_Group_PlanningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planung`)
};

/**
* | output |
* | --- |
* | "Planning" |
*
* @param {Settings_Group_PlanningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_group_planning = /** @type {((inputs?: Settings_Group_PlanningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Group_PlanningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_group_planning(inputs)
	return en_settings_group_planning(inputs)
});